import { eHierarchyLevel } from "functions/api/enums";
import { eTlfType } from "functions/api/styles/getAllStyles";

/**
 * The hierarchy levels that are classified as Template-type levels. All other levels
 * (Study, Report) are classified as Shell-type levels.
 */
const templateLevels: (eHierarchyLevel | undefined)[] = [
  eHierarchyLevel.TopLevel,
  eHierarchyLevel.Corporate,
  eHierarchyLevel.TA,
  eHierarchyLevel.Project,
];

/**
 * Determines the TLF type (Template or Shell) associated with a hierarchy level.
 *
 * @param level - The hierarchy level to check
 * @returns eTlfType.Template if the level is a template-level hierarchy, otherwise eTlfType.Shell
 */
export const getHierarchyTlfType = (level: eHierarchyLevel): eTlfType => {
  return templateLevels.includes(level) ? eTlfType.Template : eTlfType.Shell;
};
